<template>
  <div id="calculation" class="pb-4" :class="disableCopy">
    <div class="text-center py-4 head mb-4" v-if="!$route.meta.hideNavFooter">
      <h1 v-if="actualUrl === 'esg888'">旅費試算 - 台灣旅遊</h1>
      <h1 v-else>入境台灣旅遊費用測算</h1>
    </div>
    <b-container ref="container">
      <b-form class="p-4 blurform" @submit="submit">
        <!-- 使用者須先選擇旅遊類型、旅遊人數、旅遊天數 -->
        <b-row>
          <b-col cols="12">
            <h5 class="text-center mt-3 mb-5"><b>1.台灣旅遊費用測算, 根據下列畫面, 輸入您的需求後, 可以快速評估您的旅遊費用</b></h5>
          </b-col>
          <b-col cols="12" md="6">
            <b-form-group label='旅遊類型'>
              <b-form-radio inline v-model="form.travel_type" value="pure">純旅遊</b-form-radio>
              <b-form-radio inline v-model="form.travel_type" value="golf">高爾夫旅遊</b-form-radio>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="6">
            <b-form-group label='旅遊總人數'>
              <div class="smtxt subtxt">會依照您填入的人數精準算出每個人的費用, 並作出派車建議及成本計算</div>
              <b-form-input min="1" type="number" v-model.number='form.num_of_people'>
              </b-form-input>
            </b-form-group>
          </b-col>
          <!-- <b-col cols="12" md="6">
            <b-form-group
              label='不佔床人數'>
              <div class="smtxt subtxt">6歲或身高110公分以下, 可選擇不佔床, 不佔床者不收取費用, 亦無提供早餐(除非另購), 詳細以各飯店的規定為準</div>
              <b-form-input
                min="0"
                type="number"
                v-model.number='form.noAddBedNumOfPeople'>
              </b-form-input>
            </b-form-group>
          </b-col> -->
          <b-col cols="12" md="6">
            <b-form-group label='旅遊天數'>
              <div class="smtxt subtxt">旅遊天數會影響每天的用車成本</div>
              <b-form-input min="1" type="number" v-model='form.num_of_days'>
              </b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="6" md="4" v-if="form.num_of_days > 1">
            <b-form-group label='是否南進北出/北進南出'>
              <b-form-radio inline v-model="form.car_extra_charge" :value="true">是</b-form-radio>
              <b-form-radio inline v-model="form.car_extra_charge" :value="false">否</b-form-radio>
            </b-form-group>
          </b-col>
        </b-row>
        <hr>
        <!-- 每天的選單 -->
        <b-row class="my-3 pt-3 day_area rounded mb-3" v-for="(day, index) in detail" :key="index">
          <b-col cols="12">
            <h5 class="text-center ">第{{ index + 1 }}天</h5>
          </b-col>
          <!-- <b-col cols="12">
            <div class="text-center my-2 subtitle">飯店、景點</div>
          </b-col> -->
          <b-col cols="4" v-if="index === 0">
            <b-form-group label='日期'>
              <v-date-picker v-model="form.date" mode="date" :min-date="new Date()">
                <template v-slot="{ inputValue, inputEvents }">
                  <input class="px-2 py-1 border rounded focus:outline-none focus:border-blue-300" :value="inputValue"
                    v-on="inputEvents" />
                </template>
              </v-date-picker>
            </b-form-group>
          </b-col>
          <b-col v-if="!form.hotel_same || index === 0" cols="12">
            <b-row>
              <b-col cols="6" sm="4">
                <b-form-group label='住宿地點'>
                  <div class="smtxt subtxt">選擇住宿地點之後,再點選飯店欄位,會顯示當地的飯店清單(含等級)供選擇</div>
                  <b-form-select :options="hotel_areaOpt" v-model='optionData[index].hotel_area'>
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col cols="6" sm="4">
                <b-form-group :disabled="optionData[index].hotel_area === null" label='飯店'>
                  <b-form-select :options="optionData[index].hotel_area" v-model='detail[index].hotel_id'>
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col v-if="form.num_of_days > 2 && index === 0">
                <b-form-group :label='optionData[index].hotel_area === null ? "每天都自行安排住宿" : "每天住同一間飯店(最後一天不住宿)"'>
                  <b-form-radio inline v-model="form.hotel_same" :value="true">是</b-form-radio>
                  <b-form-radio inline v-model="form.hotel_same" :value="false">否</b-form-radio>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="12">
            <hr>
          </b-col>

          <!-- 景點 -->
          <b-col cols="6" sm="4">
            <b-form-group label='是否選擇景點'>
              <div class="smtxt subtxt">
                選擇"是"之後, 會列出台灣各旅遊縣市供您選擇, 選定縣市後, 會顯示主要旅遊景點的清單, 並作出旅遊路線的選擇記錄
              </div>
              <b-form-radio inline @change="attractionChange(index)" v-model="detail[index].choose_attraction"
                :value="true">是</b-form-radio>
              <b-form-radio inline @change="attractionChange(index)" v-model="detail[index].choose_attraction"
                :value="false">否</b-form-radio>
            </b-form-group>
          </b-col>

          <!-- 新地區 -->
          <b-col cols="12">
            <b-form-group v-if="detail[index].choose_attraction" label='景點區域'>
              <span v-for="(i, index2) in spotarray" :key="index2 + 'i2'">
                <b-form-checkbox @change="changeSpotArea(index, i)" inline :value="i" v-model="detail[index].spot_area">
                  {{ i.label }}
                </b-form-checkbox>
              </span>
            </b-form-group>
          </b-col>
          <b-col cols="12" v-if="detail[index].choose_attraction">
            <b-form-group label='景點'>
              <div v-for="(level2, index2) in detail[index].spot_area" :key="index2 + 'i2'">
                <div v-for="(level3, index3) in level2.child" :key="index3 + 'i3'">
                  <div class="subtxt">{{ level2.label + '-' + level3.label }}</div>
                  <b-form-checkbox v-model="detail[index].spot_array" inline :value="spot.value"
                    v-for="(spot, index4) in level3.options" :key="index4 + 'i4'">{{ spot.text }}
                  </b-form-checkbox>
                </div>
              </div>
            </b-form-group>
          </b-col>

          <!-- 球場 -->
          <b-col cols=12 v-if="form.travel_type === 'golf'">
            <hr>
            <!-- <div class="text-center my-2 subtitle">球場</div> -->
          </b-col>
          <b-col v-if="form.travel_type === 'golf'" cols="12" sm="4">
            <b-form-group label='球場區域'>
              <b-form-select :options="courtData" v-model='detail[index].court_id'>
              </b-form-select>
            </b-form-group>
          </b-col>

          <!-- 導遊服務 -->
          <b-col cols="12">
            <hr>
          </b-col>
          <b-col cols="6" sm="6" v-if="!form.guide_service_same || index === 0">
            <b-form-group label='導遊服務'>
              <div class="smtxt subtxt">有華語及英語導遊的選擇, 如需其它語言別, 可在郵件中註明.當然您也可以不派選導遊</div>
              <b-form-select @change="guideChanged(index)" v-model='detail[index].guide'>
                <!-- 記得改預設值 -->
                <b-form-select-option value='華語導遊' v-if="form.num_of_people >= 9">華語導遊</b-form-select-option>
                <b-form-select-option value='英、日語導遊' v-if="form.num_of_people >= 9">英、日語導遊</b-form-select-option>
                <b-form-select-option value='華語車導' v-if="form.num_of_people < 9">華語車導</b-form-select-option>
                <b-form-select-option value='英、日語車導' v-if="form.num_of_people < 9">英、日語車導</b-form-select-option>
                <b-form-select-option value='另聘其它語系導遊'>另聘其它語系導遊</b-form-select-option>
                <b-form-select-option value='不需服務'>不需服務</b-form-select-option>
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col v-if="form.num_of_days > 1 && index === 0">
            <b-form-group label='每天導遊服務需求皆相同'>
              <b-form-radio inline v-model="form.guide_service_same" :value="true">是</b-form-radio>
              <b-form-radio inline v-model="form.guide_service_same" :value="false">否</b-form-radio>
            </b-form-group>
          </b-col>
          <!-- 派車 -->
          <b-col cols=12>
            <hr>
            <!-- <div class="text-center my-2 subtitle">派車</div> -->
          </b-col>
          <b-col cols="6">
            <b-form-group label='車輛服務'>
              <div class="smtxt subtxt">四種選擇: 不派車、全日用車、純接送或者半日遊,不同用車情況代表著不同費用</div>
              <b-form-select @change="carOptchanged(index)" :options="car_serviceOpt"
                v-model='optionData[index].car_service'>
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col cols="6" v-if="!form.car_service_same || index === 0">
            <b-form-group label='車型'>
              <div class="smtxt subtxt">會依照您選擇的人數做合理的派用</div>
              <b-form-select :disabled="optionData[index].car_service === '不派車'" :options="detail[index].car_typeOpt"
                v-model='detail[index].car_id'>
              </b-form-select>
              <div v-if="['9', '6', '5', '4'].includes(detail[index].car_id)">每日用車上限10小時</div><!--九人以下車-->
              <div v-if="['7', '8'].includes(detail[index].car_id)">每日用車上限11小時</div><!--九人以上車-->
            </b-form-group>
          </b-col>
          <b-col v-if="form.num_of_days > 1 && index === 0">
            <b-form-group label='每天用車車型皆相同'>
              <b-form-radio inline v-model="form.car_service_same" :value="true">是</b-form-radio>
              <b-form-radio inline v-model="form.car_service_same" :value="false">否</b-form-radio>
            </b-form-group>
          </b-col>
          <!-- 用餐 -->
          <b-col v-if="!form.meal_same || index === 0" cols=12><!-- 選擇餐費不同，或是第一天，才會出現-->
            <b-row>
              <b-col cols=12>
                <hr>
              </b-col>
              <b-col cols="6">
                <b-form-group label='是否用餐'>
                  <div class="smtxt subtxt">可以有用不用餐的選擇.如不用餐,需貼補司機、導遊的誤餐費</div>
                  <b-form-select v-model='optionData[index].meal'>
                    <b-form-select-option value="用餐">用餐</b-form-select-option>
                    <b-form-select-option value="不用餐">不用餐</b-form-select-option>
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group label='餐費'>
                  <div class="smtxt subtxt">餐費是指一人一天兩餐的總費用, 餐費可以自行選擇</div>
                  <b-form-select :disabled="optionData[index].meal === '不用餐'" :options="meal_feeOpt"
                    v-model='detail[index].meal_fee'>
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col v-if="form.num_of_days > 1 && index === 0">
                <b-form-group label='每天餐費皆相同'>
                  <b-form-radio inline v-model="form.meal_same" :value="true">是</b-form-radio>
                  <b-form-radio inline v-model="form.meal_same" :value="false">否</b-form-radio>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <div class="text-center my-4">
          <h5 class="text-center mt-3 mb-"><b>2.點選計算</b></h5>
          <b-btn variant="warning" ref="computeBtn" :disabled="computeBtnDisable" @click="computedFee()">計算<span
              v-if="computeBtnDisable">中</span></b-btn>
          <div class="smtxt mt-2">可即時計算出每人的費用報價, 並會依您的選擇, 在報價上, 作出實際的行程內容</div>
        </div>

        <!-- <hr> -->
        <h5 class="text-center mb-3"><b>試算結果</b></h5>
        <div class="px-3 py-4 border rounded">
          <div v-if="computeBtnDisable" rounded="sm" class="p-3 text-center">
            <b-icon class="my-2" icon="hourglass-bottom" animation="spin-pulse"></b-icon>
          </div>
          <b-row>
            <b-col>
              <div v-html="responseInfo"></div>
            </b-col>
            <b-col>
              <div v-html="adminResponseInfo"></div>
            </b-col>
          </b-row>
        </div>
        <!-- <div>每人預估費用</div> -->
        <hr>
        <b-row>
          <b-col cols="12">
            <h5 class="text-center mb-3"><b>3.填寫聯絡人資訊</b></h5>
            <div class="smxt mb-2">填寫好下列資料並送出後, 會把您上列的選擇EMAIL給您, 方便留存, 而我公司也會收到附本, 並依據您的需求, 與您聯絡及確認後續的安排</div>
          </b-col>
          <b-col cols="12" sm="6">
            <b-form-group label='姓名(必填)'>
              <b-form-input required v-model='contact_data.name'>
              </b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6">
            <b-form-group label='電話(必填)'>
              <b-form-input required v-model='contact_data.phone'>
              </b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group :label='"Email(必填)"' invalid-feedback="請輸入正確格式的電子信箱">
              <div class="subtxt">如欲寄送給多個Email(最多3個)，請以分號分隔。如：mail1@gmail.com;mail2@gmail.com</div>
              <b-form-input @keyup="checkEmailQty" required v-model='contact_data.email'>
              </b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group label='備註'>
              <b-form-textarea v-model='contact_data.memo'>
              </b-form-textarea>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="驗證碼(必填)" invalid-feedback="請輸入下方的四位數驗證碼，若看不清楚，可點選圖片重新生成">
              <b-form-input autocomplete="off" required placeholder="請輸入下方的四位數驗證碼" v-model="vali_code"
                :state="state.checkVCode"></b-form-input>
            </b-form-group>
            <div class="identifyCode" @click="refreshCode2" style="cursor: pointer;">
              <Identify2 :identifyCode2="identifyCode2"></Identify2>
            </div>
          </b-col>
        </b-row>
        <div class="text-center">
          <b-button type="submit" class="okBtn text-white"
            :disabled="!state.checkVCode || responseInfo.length === 0 || sendMailBtnDisable">
            送出<span v-if="sendMailBtnDisable">資料中</span>
          </b-button>
        </div>
      </b-form>
    </b-container>
  </div>
</template>

<script>
import Identify2 from '@/components/Identify2.vue'

export default {
  components: {
    Identify2
  },
  data() {
    return {
      data: {},
      spotarray: [],
      disableCopy: '',
      sendMailBtnDisable: false,
      computeBtnDisable: false,
      fields: [
        { key: 'office', label: '辦事處' },
        { key: 'name', label: '聯絡人' },
        { key: 'email', label: 'email' },
        { key: 'phone', label: '電話1' },
        { key: 'phone2', label: '電話2' },
        { key: 'contact', label: '線上通訊' }
      ],
      contactItems: [
        { name: '台北XXX', department: '台北', phone: '0919', skype: '0919', line: 'line123', whatsapp: 'dsad', qq: 'd', wechat: 'd', email: 'adf@dd.dd' },
        { name: 'XXX', department: '高雄', phone: '02', skype: '0919', line: 'line', whatsapp: '', qq: '', wechat: '' }
      ],
      adminResponseInfo: '',
      responseInfo: '',
      spotOption: [],
      optionData: [],
      carData: [],
      courtData: [],
      hotelData: [],
      // car_typeOpt: [],
      hotel_areaOpt: [],
      golf_areaOpt: [
        // '不打球', '北', '中', '南', '東'
      ],
      meal_feeOpt: [250, 500, 600, 700, 1000, 1500],
      car_serviceOpt: [
        '不派車', '全日用車', '純接送', '半日遊'
      ],
      form: {
        hotel_same: false,
        meal_same: false,
        car_extra_charge: false,
        date: '',
        car_service_same: false,
        guide_service_same: false,
        num_of_people: 1,
        // noAddBedNumOfPeople: 0,
        num_of_days: 0,
        travel_type: 'pure'
      },
      contact_data: {
        name: '',
        phone: '',
        email: '',
        memo: ''
      },
      detail: [],
      // 驗證碼
      identifyCode2: '',
      vali_code: ''
    }
  },
  watch: {
    // 如果使用者重選 detail/form/optionData 選項的話，清空計算結果，以提醒使用者要按重新計算
    detail: {
      handler: function () {
        this.responseInfo = ''
      },
      deep: true
    },
    form: {
      handler: function () {
        this.responseInfo = ''
      },
      deep: true
    },
    // 天數、人數及旅遊類型改變時，產生對應的選項
    'form.travel_type': function () {
      this.resetDetail()
    },
    'form.num_of_days': function () {
      this.resetDetail()
    },
    'form.num_of_people': function () {
      this.resetDetail()
    },
    // 監聽住宿地點、車輛服務、是否用餐、球場區域的改變，提供相對應的欄位下拉選項
    optionData: {
      handler: function () {
        this.responseInfo = ''
        this.optionData.forEach((day, index) => {
          if (day.hotel_area === null) {
            this.detail[index].hotel_id = '不住宿'
          }
          if (day.meal === '不用餐') {
            this.detail[index].meal_fee = 0
          }
        })
      },
      deep: true
    }
  },
  computed: {
    state() {
      return {
        checkVCode: this.vali_code === '' ? null : this.vali_code === this.identifyCode2
      }
    },
    // 判斷目前實際URL是明日或ESG
    actualUrl() {
      const url = document.location.href
      // console.log('u ' + url)
      if (url.includes('tstar888.com') || url.includes(':8081/')) {
        return 'tstar888'
      } else if (url.includes('esg888.com') || url.includes(':8080/')) {
        return 'esg888'
      } else return ''
    }
  },
  methods: {
    // 景點區域變動
    changeSpotArea(index) {
      console.log('changeSpotArea')
      // console.log(this.detail[index])

      // 收集 spot_area 中的所有 value
      function collectValues(areaList) {
        const values = new Set()
        areaList.forEach(area => {
          if (area.options) {
            area.options.forEach(option => values.add(option.value))
          }
          if (area.child) {
            const childValues = collectValues(area.child)
            childValues.forEach(value => values.add(value))
          }
        })
        return values
      }

      // 取所有的 spot_area 中的 value
      const validValues = collectValues(this.detail[index].spot_area)
      // 剃除 spot_array 中不在 spot_area 里的 id
      this.detail[index].spot_array = this.detail[index].spot_array.filter(spotId => validValues.has(spotId))

      // console.log('Filtered SpotIdArray: ', filteredSpotIdArray)

      console.log(this.detail[index])
    },

    // 使用者重選導遊的話，用車選項也要更新
    guideChanged(index) {
      // console.log('guideChanged')
      this.detail[index].car_id = 0
      this.carOptchanged(index)
    },

    // 用車選項更新
    carOptchanged(index) {
      // console.log('carOptchanged')
      // 車選項
      if (this.optionData[index].car_service === '不派車') {
        this.detail[index].car_id = 0 // 不派車
      } else {
        this.detail[index].car_typeOpt = []
        // 找符合人數的派車選項
        this.carData.forEach(car => {
          if (car.min <= this.form.num_of_people && this.form.num_of_people <= car.max) {
            // 例外規則:8人另聘其它語系導遊 改中巴
            if (this.form.num_of_people === 8) {
              if (this.detail[index].guide === '另聘其它語系導遊') {
                // console.log('另聘其它語系導遊')
                if (car.id === '7') this.detail[index].car_typeOpt.push({ text: car.name, value: car.id })
              } else if (car.id !== '7') this.detail[index].car_typeOpt.push({ text: car.name, value: car.id })
            } else { this.detail[index].car_typeOpt.push({ text: car.name, value: car.id }) }
          }
        })
      }
    },
    // 檢查email數量，如超過三個email，則清空多的
    checkEmailQty(e) {
      let emails = this.contact_data.email.split(';')
      if (emails.length > 3) {
        emails = emails.slice(0, 3)
        this.contact_data.email = emails.join(';')
        alert('最多輸入3個email')
      }
    },

    // 產生對應旅遊天數及對應旅遊類型的選項
    resetDetail() {
      this.detail = []
      this.optionData = []
      // 選擇純旅遊
      if (this.form.travel_type === 'pure') {
        for (let i = 0; i < this.form.num_of_days; i++) {
          this.detail.push({
            hotel_id: '',
            car_typeOpt: [],
            car_id: '',
            meal_fee: 0,
            guide: '不需服務',
            choose_attraction: false,
            spot_area: [],
            spot_array: []
          })
          this.optionData.push({
            hotel_area: null,
            car_service: '不派車',
            meal: '不用餐'
          })
        }
      }
      // 選擇高爾夫旅遊
      if (this.form.travel_type === 'golf') {
        for (let i = 0; i < this.form.num_of_days; i++) {
          this.detail.push({
            hotel_id: '',
            car_typeOpt: [],
            car_id: '',
            meal_fee: 0,
            guide: '不需服務',
            choose_attraction: false,
            spot_area: [],
            spot_array: [],
            court_id: '不打球'
          })
          this.optionData.push({
            hotel_area: null,
            car_service: '不派車',
            meal: '不用餐'
          })
        }
      }
    },
    // "是否選擇景點"選否時，連帶取消所有已勾選的景點
    attractionChange(index) {
      if (!this.detail[index].choose_attraction) {
        this.detail[index].spot_area = []
        this.detail[index].spot_array = []
      }
    },

    // 計算價格
    async computedFee() {
      this.responseInfo = '' // 清空試算資料
      this.adminResponseInfo = ''
      this.computeBtnDisable = true

      this.detail.forEach((day, index) => {
        day.car_service = this.optionData[index].car_service
      })

      // 如果飯店/用車/餐費/導遊一樣，將第一天相關資料帶入其餘天數
      if (this.form.hotel_same) {
        this.detail.forEach((day, index) => {
          if (index === this.detail.length - 1) {
            // console.log('第' + (index + 1) + '天不住宿')
            return
          }
          day.hotel_area = this.detail[0].hotel_area
          day.hotel_id = this.detail[0].hotel_id
        })
      }
      if (this.form.car_service_same) {
        this.detail.forEach((day) => {
          // day.car_service = this.detail[0].car_service
          day.car_id = this.detail[0].car_id
        })
      }
      if (this.form.meal_same) {
        this.detail.forEach((day) => {
          day.meal = this.detail[0].meal
          day.meal_fee = this.detail[0].meal_fee
        })
      }
      if (this.form.guide_service_same) {
        this.detail.forEach((day) => {
          day.guide = this.detail[0].guide
        })
      }

      this.data.form = this.form
      this.data.detail = this.detail

      // domain，為辨別tstar或esg的依據
      this.data.domain = this.actualUrl

      console.log('data')
      console.log(this.data)
      try {
        const { data } = await this.api.post('php_modules2/price.php?type=calculate', this.data)
        console.log(data)
        if (data.success) {
          this.responseInfo = data.description
          this.adminResponseInfo = data.adminDescription
          this.computeBtnDisable = false
        } else {
          this.computeBtnDisable = false
          alert(data.message)
        }
      } catch (error) {
        console.log(error)
      }

      if (this.form.travel_type === 'golf') {
        this.contact_data.memo = '希望開球時間:'
      } else this.contact_data.memo = ''
    },

    // 寄信 (寄信次數限制：一般3次/天、會員10次/天)
    async submit(e) {
      e.preventDefault()
      // this.data = {}
      // this.data.userData = {}

      // 警告:管理員身分(檢查如果是管理員身分，因報價含成本等內容，確認使用者是否仍要寄信)
      let cancel = false
      if (this.$store.getters.loginRole === 'staff') {
        // this.data.userData.memberId = this.$store.state.user.id
        await this.$swal({
          type: 'waning',
          title: '目前為管理員身分，報價含成本等內容，確定寄出信件?',
          showCancelButton: true,
          confirmButtonColor: '#dc3545',
          confirmButtonText: '確定',
          cancelButtonText: '取消'
        }).then((result) => {
          if (!result.value) {
            cancel = true
          }
        })
      }
      if (cancel) return

      this.sendMailBtnDisable = true
      this.data.contact_data = this.contact_data
      this.data.responseInfo = this.responseInfo
      this.data.adminResponseInfo = this.adminResponseInfo
      this.contact_data.email = this.contact_data.email.replace(/\s/g, '') // email欄位去除空格

      // domain，為辨別tstar或esg的依據
      this.data.domain = this.actualUrl
      console.log(this.data)

      try {
        if (this.data.domain === 'esg888') {
          console.log('esg888')
          this.data.esgData = this.esgData
        }
        const { data } = await this.api.post('php_modules2/price.php?type=sendmail', this.data)
        console.log(data)
        this.sendMailBtnDisable = false
        if (data.success) {
          await this.$swal({
            icon: 'success',
            text: '寄信成功！',
            showConfirmButton: false,
            timer: 1500
          })
        } else {
          // email格式錯誤警告
          if (data.message === 'Email格式錯誤') {
            let invalidEmails = ''
            data.invalidEmails.forEach((email, index) => {
              if (index > 0) {
                invalidEmails = invalidEmails + '; ' + email
              } else invalidEmails = email
            })
            this.$swal({
              icon: 'error',
              html: data.message + ':' + invalidEmails
            })
          } else { // 其他錯誤
            this.$swal({
              icon: 'error',
              text: data.message
            })
          }
        }
        this.refreshCode2()
        this.vali_code = ''
      } catch (error) {
        console.log(error)
      }
    }
  },
  async created() {
    // console.log('act ' + this.actualUrl)
    // console.log(this.$store.state.group)
    // 進入頁面時，傳會員ID、IP，取得剩餘可計算/寄信次數
    try {
      this.data = {}
      this.data.userData = {}
      this.data.domain = this.actualUrl

      // 記IP(因有對同一IP限制計算及寄信次數)
      const res = await this.api.get('https://api.ipify.org?format=json')
      this.data.ip = res.data.ip

      // 判斷目前是TSTAR或ESG，儲存會員ID(如果是管理員身分，特別註記)
      if (this.actualUrl === 'tstar888') {
        if (this.$store.getters.loginRole === 'member') { // 一般會員ID
          this.data.userData.memberId = this.$store.state.member.id
        } else if (this.$store.getters.loginRole === 'staff') { // 管理員ID
          this.data.userData.memberId = this.$store.state.user.id
          this.data.userData.admin = true
        }
      } else if (this.actualUrl === 'esg888') {
        this.data.userData.memberId = this.$store.state.user.id
      }
      const { data } = await this.api.post('php_modules2/price.php?type=r', this.data)
      console.log(data)

      // 區分是一般使用者或是管理員
      // if (this.$store.getters.loginRole === 'staff') {
      //   const { data } = await this.api.post('php_modules2/price.php?type=r&admin=true', this.data)
      //   console.log(data)
      // } else {
      //   const { data } = await this.api.post('php_modules2/price.php?type=r', this.data)
      //   console.log(data)
      // }
    } catch (error) {
      console.log(error)
    }

    // console.log(window.location)
    this.form.num_of_days = 1
    // 飯店
    try {
      const { data } = await this.api.post('php_modules2/hotel.php?type=r&area_id=44&language=tw')
      // console.log('飯店')
      // console.log(data)
      // 轉換資料格式以符合select選單格式
      data.level2_data.forEach(area => {
        this.hotel_areaOpt.push({ text: area.label, value: Object.values(area.options) })
      })
      this.hotel_areaOpt.unshift({ text: '不住宿', value: null })
    } catch (error) {
      console.log(error)
    }

    // 景點
    // spot.php?type=r&area_id=44 北台灣 台灣
    try {
      const { data } = await this.api.post('php_modules2/spot.php?type=r&area_id=44&language=tw')
      // console.log('景點')
      // console.log(data)
      this.spotarray = data.level2_data
    } catch (error) {
      this.$swal({
        icon: 'error',
        title: '錯誤',
        text: '讀取景點選項失敗' + error
      })
    }

    // 球場
    try {
      const { data } = await this.api.post('php_modules2/golf.php?type=r&area_id=44&language=tw')
      // console.log('球場')
      // console.log(data)
      this.courtData = data.level2_data
      this.courtData.unshift({ text: '不打球', value: '不打球' })
    } catch (error) {
      console.log(error)
    }

    // 車 &area='北台灣'
    try {
      // !指定areaID的景點
      const { data } = await this.api.post('php_modules2/car.php?type=r&area_id=44&language=tw')
      // console.log('car.php?type=r')
      // console.log(data)
      this.carData = data.data
      this.carData = data.data.filter(item => item.areaName1 === '北台灣')
    } catch (error) {
      console.log(error)
    }
  },
  async mounted() {
    this.refreshCode2()

    console.log('actualUrl' + this.actualUrl)
    // 不是會員:鎖右鍵
    if ((this.actualUrl === 'esg888' && !this.$store.getters.isLogin) ||
      (this.actualUrl === 'tstar888' && !this.$store.state.user.id)) {
      this.disableCopy = 'disableCopyStyle'
      document.oncontextmenu = function () { return false }
      document.body.oncopy = function () { return false }
    } else {
      this.disableCopy = ''
      document.oncontextmenu = null
      document.body.oncopy = null
    }
    if (this.actualUrl === 'esg888') {
      this.disableCopy += ' text-left'
    }
  }
}
</script>
<style lang="scss">
.disableCopyStyle {
  user-select: none;
  /* standard syntax */
  -webkit-user-select: none;
  /* for Chrome、Safari */
  -moz-user-select: none;
  /* for Mozilla、Firefox */
}

#calculation {
  legend {
    // border-radius: 5px;
    padding-left: 9px;
    padding-bottom: 2px;
    background-color: var(--vcBlue);
    margin-bottom: 3px;
  }

  h1 {
    letter-spacing: 1px;
    font-size: 1.6em;
  }

  .head {
    background-color: var(--vcBlue);
  }

  .blurform input {
    margin: 0;
  }

  .subtitle {
    font-weight: 500;
    color: var(--myblue);
  }

  .day_area:nth-child(odd) {
    background-color: #f2f8fc;
  }

  .day_area:nth-child(even) {
    background-color: rgb(246, 246, 246);
  }

  thead {
    background-color: var(--myblue);
    color: #fff;
  }

  .custom-control-inline {
    margin-bottom: 6px;
  }

  @media (min-width: 768px) {
    .container {
      max-width: 800px;
    }
  }
}
</style>
